import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/user.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import {HttpClient} from '@angular/common/http';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import{saveAs} from 'file-saver'
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-score',
  templateUrl: './score.component.html',
  styleUrls: ['./score.component.scss']
})
export class ScoreComponent implements OnInit {
    isSaving:boolean=false;
    currentManagementFee: string;
    currentInvestmentFee: string;
    newManagementFee: string;
    newInvestmentFee: string;

    currentLastName: string;
    currentPhone: string;
    currentEmail: string;
    newLastName: string;
    newPhone: string;
    newEmail: string;


    management_fee: Number;
    investment_fee: Number;

    last_name: string;
    phone: string;
    email: string;

    contact_response: any;

    chipscore_response: any;
    chipscore: any;
    session_response: any;
    have_statistic: any;
    income_expense: any;

    progress_bar_type: any;
    score_description: any;
    Formatdate:any;
    CustomerName:any;

    upside_capture_ratio:any;
    downside_capture_ratio:any;

    loading:boolean=false;
    isVidLoading=true;

    constructor(public user: UserService, private modalService: NgbModal,private http:HttpClient,private toastr:ToastrService,private spinner: Ng4LoadingSpinnerService) {

    }
    ngOnInit() {

      if (localStorage.getItem('current_have_statistic') != undefined){
        this.user.getStatistic(localStorage.getItem('current_have_statistic')).subscribe(statistic =>{
          this.have_statistic = statistic;


          if (localStorage.getItem('current_income_expense') != undefined){
            console.log('Income Expense defined!');
            this.user.getIncomeExpense(localStorage.getItem('current_income_expense')).subscribe(income_expense =>{
              this.income_expense = income_expense;
              this.addChipscore();
            });
          }
          console.log('Income Expense Undefined!');
        });
      }
      if (localStorage.getItem('current_chipscore_id') != undefined){
          this.user.getChipscore(localStorage.getItem('current_chipscore_id')).subscribe(chipscore =>{
              this.chipscore = chipscore;
          });
      }
      this.user.currentManagementFee.subscribe(currentManagementFee => {
          this.currentManagementFee = currentManagementFee;
          this.newManagementFee = currentManagementFee;
      });
      this.user.currentInvestmentFee.subscribe(currentInvestmentFee => {
          this.currentInvestmentFee = currentInvestmentFee;
          this.newInvestmentFee = currentInvestmentFee;
      });
      this.user.currentLastName.subscribe(currentLastName => {
          this.currentLastName = currentLastName;
          this.newLastName = currentLastName;
      });
      this.user.currentPhone.subscribe(currentPhone => {
          this.currentPhone = currentPhone;
          this.newPhone = currentPhone;
      });
      this.user.currentEmail.subscribe(currentEmail => {
          this.currentEmail = currentEmail;
          this.newEmail = currentEmail;
      });

      this.getFormatdate();

    }
    editManagementFee(){
        this.user.editManagementFee(this.newManagementFee);
    }
    editInvestmentFee(){
        this.user.editInvestmentFee(this.newInvestmentFee);
    }
    editLastName(){
        this.user.editLastName(this.newLastName);
    }
    editPhone(){
        this.user.editPhone(this.newPhone);
    }
    editEmail(){
        this.user.editEmail(this.newEmail);
    }
    // Posting the allocation
    addChipscore(){

        this.user.currentManagementFee.subscribe(result => {
            this.management_fee = Number(result);
        });
        this.user.currentInvestmentFee.subscribe(result => {
            this.investment_fee = Number(result);
        });
        var newChipscore = {
            income_expense_id: localStorage.getItem('current_income_expense'),
            have_statistics_id: localStorage.getItem('current_have_statistic'),
            risk_free_rate: 0.01,
            management_fee_rate: this.management_fee,
            investment_fee_rate: this.investment_fee
        }
        this.user.addChipscore(newChipscore).subscribe(chipscore_response =>{

            this.chipscore_response = chipscore_response;
            this.chipscore = this.chipscore_response.createdChipscore;
            localStorage.removeItem('current_chipscore_id');
            localStorage.setItem('current_chipscore_id', this.chipscore_response.createdChipscore._id);

            //Update the progress bar
            this.getProgressBarType(this.chipscore.chipscore);
            let body = [
                {
                  "propName": "chipscore_id",
                  "value": this.chipscore_response.createdChipscore._id
                }
            ]
            // // Create a new session associated with income expense
            // this.user.editSession(localStorage.getItem('current_session_id'), body).subscribe( session_response =>{
            //     // console.log(session_response);
            //     this.session_response = session_response;
            // });
        });

    }
    // Needs to get the fields from the contact form
    addContact(){
      if (this.validateContactInformation()){
        console.log('Validated');
        this.user.currentLastName.subscribe(last_name => {
          this.last_name = String(last_name);
        });
        this.user.currentPhone.subscribe(phone => {
          this.phone = String(phone);
        });
        this.user.currentEmail.subscribe(email => {
          this.email = String(email);
        });
        var html = '';
        html += document.getElementById('chipscore-box').innerHTML;
        html += '<p>Contact Information:';
        html += '<br>';
        html += 'Email: ' + this.email;
        html += '<br>';
        html += 'Phone: ' + this.phone  + '<p>';
        this.user.html_body += html;
        var newContact = {
          name: this.last_name,
          phone: this.phone,
          email: this.email,
          body: this.user.html_body
        }
        this.loading=true;
        this.user.addContact(newContact).subscribe(contact_response => {
          this.loading=false
          this.contact_response = contact_response;
          this.toastr.success("Contact Information Received!");
        },(error)=>{
          this.loading=false
          this.toastr.success("Something went wrong!");
        });
      }
      else{
        console.log('Invalidated');
      }
    }
    validateContactInformation(){
        this.user.currentLastName.subscribe(last_name => {
            this.last_name = String(last_name);
        });
        this.user.currentPhone.subscribe(phone => {
            this.phone = String(phone);
        });
        this.user.currentEmail.subscribe(email => {
            this.email = String(email);
        });
  		if (this.last_name.length < 1) {
			this.toastr.warning("Name is required!");
			// $("#cName").focus();
			return false;
        }
        else {
          console.log(this.last_name)
            var name_filter = /^[A-Za-z\s]*$/;
			if (!name_filter.test(this.last_name))
			{
			    this.toastr.warning("Name can only contain alphabets");
			    // $("#cName").focus();
			    return false;
			}
		}
		if (this.email.length < 1) {
			this.toastr.warning("Email address is required!");
			// $("#emailChip").focus();
			return false;
        }
        else {
		    var email_filter = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z\-])+\.)+([a-zA-Z]{2,4})+$/;
		    if (!email_filter.test(this.email)) {
                this.toastr.warning("Please provide a valid email address");
                // $("#emailChip").focus();
                return false;
			}
		}
		 if (this.phone.length < 1) {
			this.toastr.warning("Phone Number is required!");
			// $("#phoneChip").focus();
			return false;
        }
      //   else {
			// var phone_filter = /^\d{3}-\d{3}-\d{4}$/;
		  // 	if(!phone_filter.test(this.phone)){
		  //       this.toastr.warning("Phone Number is not a valid, XXX-XXX-XXXX");
		  //       // $("#phoneChip").focus();
		  //       return false;
		  //   }
      // }
      return true;
    }
    sendEmail(){
        this.addContact();
    }
    openModal(content) {
        this.modalService.open(content, {backdropClass: 'light-blue-backdrop', windowClass : 'myCustomModalClass'});
    }
    getProgressBarType(chipscore){
        if (chipscore<=30){
            this.progress_bar_type = 'danger';
            this.score_description = 'Your Chip Score is less than 30! Requires immediate professional input since your current portfolio is unsustainable. We believe that you should consider our recommendations to improve your investment. Please contact us immediately.';
        }
        else if(chipscore<=50){
            this.progress_bar_type = 'warning';
            this.score_description = 'Your Chip Score is between 30 and 50. Your portfolio still has room for improvements. Would you like recommendations from our Professional Management team?';
        }
        else{
            this.progress_bar_type = 'success';
            this.score_description = 'Your Chip Score is above 50. Your portfolio looks promising. If you would still like some recommendations from our Professional Management team, please let us know.';
        }

    }


    getPDF()
    {

     let payload={
      name:this.CustomerName,
      porfilio_feed:JSON.parse(localStorage.getItem('portfolio_feed')),
      current_portfolio_allocation:JSON.parse(localStorage.getItem('current_portfolio_allocation')),
      table_data:{
        'rate_of_return':this.have_statistic.rate_of_return,
        'standard_deviation':this.have_statistic.standard_deviation,
        'real_rate_of_return':this.chipscore.real_rate_of_return,
        'variance_drag_phantom_tax':this.have_statistic.variance_drag_phantom_tax,
        'sharpe_ratio':this.have_statistic.sharpe_ratio,
        'probability_of_any_loss_in_the_next_12_months':this.have_statistic.probability_of_any_loss,
        'amount_of_money_at_risk_in_the_next_12_months':this.have_statistic.amount_of_money_at_risk,
        'upper_return':this.have_statistic.upper_return,
        'lower_return':this.have_statistic.lower_return,
        'beta':this.have_statistic.beta,
        'cost_of_living_increase':this.income_expense.cost_of_living_increase,
        'tax_bracket':this.income_expense.tax_bracket,
        'risk_free_rate':this.chipscore.risk_free_rate,
        'chipscore':this.chipscore.chipscore,
        "upside_capture_ratio":this.have_statistic.capture_ratio.upside_capture_ratio,
        "downside_capture_ratio":this.have_statistic.capture_ratio.downside_capture_ratio,
        'ulcer_index':this.have_statistic.ulcer_index
      }
    }
    this.isSaving = true;
    this.http.post(this.user.downloadPdf()+'chipscorepdf',payload,{responseType:'arraybuffer'})
    .subscribe(res=>{
     this.isSaving=false;
     if(res.byteLength>5)
     {
     var blob = new Blob([res],{type:'application/pdf'});
     const filename="chipscore.pdf"
     saveAs(blob,filename)
     }
    },
    (err)=>{
      this.isSaving=false;
      // this.spinnerService.hide()
      if(err)
      {
        console.log(err)
       this.toastr.error("Something went wrong!","CHIPSCORE")
      }
    }
    )

    }

    sendModal() {
      this.CustomerName=(<HTMLInputElement>document.getElementById("customername")).value;
      if(this.CustomerName.length>0){
        this.hideModal();
        // this.Print();
        this.getPDF()
      }
      else if(this.CustomerName!=""){
        this.showModal();
      }
      (<HTMLInputElement>document.getElementById("customername")).value='';

    }

    hideModal() {
      document.getElementById('close-modal').click();
    }

    showModal() {
      this.setShowModal(true);
    }

    setShowModal(bool: true) {
      // console.log("hello");
    }

    getFormatdate(){
      const today = new Date();
      var dd = String(today.getDate()).padStart(2, '0');
      var mm = String(today.getMonth() + 1).padStart(2, '0');
      var yyyy = today.getFullYear();
      this.Formatdate = mm + '/' + dd + '/' + yyyy;
    }


}
